<template>
    <section id="about" class="bg-white-2">
        <div class="container">
            <div class="row no-padding-rl no-padding-top padding-8">
                <div class="col-md-8 col-md-offset-2 text-center">
                    <h3 class="font-family-alt font-weight-700 letter-spacing-2 text-uppercase xs-title-small title-medium title-sideline-base-color">Praktiske informationer</h3>
                    <!--<p class="font-family-alt margin-3 no-margin-bottom no-margin-rl text-gray-dark-2 text-large">Du vil møde en masse spændende mennesker.</p>-->
                </div>
            </div>
            <div class="row">
                <div class="col-md-5 xs-text-center">
                    <p class="vw-bold font-family-alt text-extra-large">{{ title }}</p>
                    <p class="margin-5-5 no-margin-bottom no-margin-rl text-large text-gray-dark-2">
                        <slot name="text"></slot>
                    </p>
                    <a class="page-scroll btn btn-outline-black btn-medium margin-6-5 no-margin-bottom no-margin-rl"
                       @click="goToMenuItem('register')"
                    >
                        Tilmeld dig nu
                    </a>
                </div>
                <div class="col-md-6 col-md-offset-1">
                    <div class="row">
                        <div class="col-sm-6 xs-margin-10 sm-margin-5 xs-no-margin-bottom sm-no-margin-bottom xs-no-margin-rl sm-no-margin-rl xs-text-center">
                            <i class="fa fa-map-marker display-block text-base-color title-extra-large-2"></i>
                            <span class="display-block font-family-alt font-weight-700 letter-spacing-1 margin-5 no-margin-bottom no-margin-rl text-large text-uppercase vw-bold">Adresse</span>
                            <p class="margin-3 no-margin-bottom no-margin-rl text-large text-gray-dark-2">
                                <slot name="address"></slot>
                            </p>
                        </div>
                        <div class="col-sm-6 xs-margin-10 sm-margin-5 xs-no-margin-bottom sm-no-margin-bottom xs-no-margin-rl sm-no-margin-rl xs-text-center">
                            <i class="fa fa-clock-o display-block text-base-color title-extra-large-2"></i>
                            <span class="display-block font-family-alt font-weight-700 letter-spacing-1 margin-5 no-margin-bottom no-margin-rl text-large text-uppercase vw-bold">Dato & tid</span>
                            <!--<p class="margin-3 no-margin-bottom no-margin-rl text-large text-gray-dark-2">
                                Torsdag,<br>
                                14. December 2017<br>
                                Kl. 06.30 - 08.00<br>&nbsp;
                            </p>-->
                            <p class="margin-3 no-margin-bottom no-margin-rl text-large text-gray-dark-2">
                                <slot name="datetime"></slot>
                            </p>
                        </div>
                        <div class="col-sm-12 sm-margin-5 sm-no-margin-bottom sm-no-margin-rl xs-text-center">
                            <br>
                            <i class="fa fa-handshake-o display-block text-base-color title-extra-large-2"></i>
                            <span class="display-block font-family-alt font-weight-700 letter-spacing-1 margin-5 no-margin-bottom no-margin-rl text-large text-uppercase vw-bold">Partnere</span>
                            <p class="margin-3 no-margin-bottom no-margin-rl text-large text-gray-dark-2 partners">
                                <slot name="partners"></slot>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import $ from 'jquery'
    export default {
        props: {
            title: {
                type: String,
                required: true
            }
        },
        methods: {
            goToMenuItem (id) {
                this.showMenu = false
                $('html, body').animate({
                    scrollTop: $('#' + id).offset().top
                }, 500)
            }
        }
    }
</script>
<style scoped>
    p.partners a{
        margin-right: 15px;
        margin-bottom: 15px;
    }
</style>



// WEBPACK FOOTER //
// practical-info.vue?6535b61e